import script from "./UserFollowView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFollowView.vue?vue&type=script&setup=true&lang=js"

import "./UserFollowView.vue?vue&type=style&index=0&id=1ab96dce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab96dce"]])

export default __exports__